import { useCallback, useEffect, useRef, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

const PHRASES = [
  "Criação de Sites Profissionais",
  "Tráfego Pago",
  "Rastreamento de Conversões",
  "Estratégia e Crescimento Digital",
];

export const Marquee = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "center" });
  const [index, setIndex] = useState(0);
  const timer = useRef(null);

  const onSelect = useCallback(() => {
    if (emblaApi) setIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  const restart = useCallback(() => {
    clearInterval(timer.current);
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduce) timer.current = setInterval(() => emblaApi && emblaApi.scrollNext(), 3200);
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return undefined;
    emblaApi.on("select", onSelect);
    restart();
    return () => clearInterval(timer.current);
  }, [emblaApi, onSelect, restart]);

  return (
    <section
      data-testid="services-carousel"
      aria-label="Serviços GOBAX em destaque"
      className="relative overflow-hidden border-y border-white/10 bg-gb-ink/60 py-16 sm:py-20"
    >
      <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[260px] w-[680px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(ellipse,rgba(199,205,214,0.07),transparent_65%)] blur-2xl" />
      <div className="relative mx-auto max-w-6xl px-4 text-center sm:px-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.32em] text-gb-silver">O que fazemos pelo seu negócio</p>

        <div className="mt-8 cursor-grab overflow-hidden active:cursor-grabbing" ref={emblaRef} data-testid="services-carousel-track">
          <div className="flex">
            {PHRASES.map((phrase, i) => (
              <div key={phrase} className="flex min-w-0 flex-[0_0_100%] items-center justify-center px-4">
                <h2
                  aria-hidden={index !== i}
                  className={`font-display text-3xl font-extrabold leading-tight tracking-tight transition-opacity duration-500 sm:text-5xl lg:text-6xl ${
                    index === i ? "chrome-text opacity-100" : "text-outline opacity-40"
                  }`}
                >
                  {phrase}
                </h2>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-9 flex items-center justify-center gap-3" role="tablist" aria-label="Escolher serviço em destaque">
          {PHRASES.map((p, i) => (
            <button
              key={p}
              type="button"
              role="tab"
              aria-selected={index === i}
              aria-label={p}
              data-testid={`services-carousel-dot-${i}`}
              onClick={() => { emblaApi && emblaApi.scrollTo(i); restart(); }}
              className={`h-1.5 rounded-full transition-all duration-500 ${index === i ? "w-10 bg-gb-silverhi" : "w-1.5 bg-white/20 hover:bg-white/45"}`}
            />
          ))}
        </div>
        <p className="mt-4 font-mono text-[10px] tracking-[0.3em] text-gb-gray/70">
          {String(index + 1).padStart(2, "0")} / {String(PHRASES.length).padStart(2, "0")}
        </p>
      </div>
    </section>
  );
};
